// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"614":"cc3a0e0b","695":"b3b87394"}[chunkId] + ".chunk.css";
};